import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'ai-batch',
  name: 'AI Batch',
  category: 'ai-nodes',
  description: 'Submit large-scale AI inference requests via batch APIs (Anthropic/OpenAI). Workflow suspends and auto-resumes when batch completes.',
  icon: 'Bot',
  color: 'purple',
  version: '1.0.0',

  group: ['ai', 'agent'],

  defaults: {
    name: 'AI Batch',
    color: 'purple'
  },

  subtitle: 'Connect model, memory, and tools',

  // No credentials needed - sub-nodes handle their own credentials
  credentials: [],

  inputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Input Data',
      required: true
    }
  ],

  outputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Results'
    }
  ],

  // Define anchors for sub-node connections (same as AI Agent)
  anchors: {
    input: [
      {
        type: 'subNode',
        subNodeCategory: 'chatModel',
        label: 'Model',
        multiple: false,
        acceptTypes: ['anthropic', 'openai', 'access-llm']
      },
      {
        type: 'subNode',
        subNodeCategory: 'memory',
        label: 'Memory',
        multiple: false,
        acceptTypes: ['simpleMemory', 'vectorMemory', 'bufferMemory']
      },
      {
        type: 'subNode',
        subNodeCategory: 'tool',
        label: 'Tools',
        multiple: true,
        acceptTypes: ['*'] // Accept any tool-capable node
      },
      {
        type: 'subNode',
        subNodeCategory: 'parser',
        label: 'Parser',
        multiple: false,
        acceptTypes: ['agentOutputParser']
      }
    ]
  },

  tags: ['ai', 'batch', 'bulk', 'async', 'anthropic', 'openai', 'cost-savings'],

  comingSoon: false
};

export default definition;
